// Типи для системи аутентифікації
export interface User {
  id: string;
  email?: string;
  phone?: string;
  first_name: string;
  last_name: string;
  role: UserRole;
  is_verified: boolean;
  phone_verified: boolean;
  created_at: string;
  updated_at: string;
  last_login_at?: string;
  login_type?: "email" | "phone"; // Тип останнього входу

  // Додаткові поля для UI
  fullName?: string; // Повне ім'я (first_name + last_name)
  phoneNumber?: string; // Номер телефону (синонім для phone)
  businessType?: string; // Тип бізнесу

  // Theme customization
  theme?: {
    navigationBg: string;
    navigationText: string;
    navigationAccent: string;
    navigationHover: string;
    headerBg: string;
    headerText: string;
  };
}

export type UserRole = "client" | "master" | "owner" | "super_admin" | "admin";

export interface RegisterData {
  email?: string;
  phone?: string;
  password: string;
  first_name: string;
  last_name: string;
  role: UserRole;
}

export interface LoginData {
  email?: string;
  phone?: string;
  password: string;
}

export interface PhoneVerificationData {
  phone: string;
  code: string;
}

export interface AuthResponse {
  message: string;
  user: User;
  token: string;
}

export interface ApiError {
  error: string;
}

// Константи ролей
export const USER_ROLES = {
  CLIENT: "client" as const,
  MASTER: "master" as const,
  OWNER: "owner" as const,
  ADMIN: "admin" as const,
} as const;

// Переклади ролей
export const ROLE_TRANSLATIONS = {
  [USER_ROLES.CLIENT]: {
    ua: "Клієнт",
    en: "Client",
  },
  [USER_ROLES.MASTER]: {
    ua: "Майстер",
    en: "Master",
  },
  [USER_ROLES.OWNER]: {
    ua: "Власник",
    en: "Owner",
  },
  [USER_ROLES.ADMIN]: {
    ua: "Адміністратор",
    en: "Administrator",
  },
} as const;
